function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 150 125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.278483,0,0,0.300089,34.5978,-0.289478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.333,266.88C348.33,266.88 323.84,262.976 300.608,255.296C289.28,251.392 276.437,254.4 268.971,261.995L222.955,296.747C170.176,268.587 136.384,234.816 108.566,182.379L142.379,137.451C150.891,128.918 153.942,116.48 150.294,104.811C142.592,81.472 138.667,56.96 138.667,32C138.667,14.357 124.31,0 106.667,0L32,0C14.357,0 0,14.357 0,32C0,237.845 167.488,405.333 373.333,405.333C390.976,405.333 405.333,390.976 405.333,373.333L405.333,298.88C405.333,281.237 390.976,266.88 373.333,266.88ZM384,373.333C384,379.221 379.2,384 373.333,384C179.242,384 21.333,226.091 21.333,32C21.333,26.112 26.133,21.333 32,21.333L106.667,21.333C112.534,21.333 117.334,26.112 117.334,32C117.334,59.243 121.601,85.995 129.963,111.36C131.2,115.349 130.198,119.467 126.294,123.52L87.467,174.933C85.014,178.197 84.63,182.57 86.486,186.197C118.123,248.341 156.545,286.784 219.137,318.848C222.742,320.725 227.158,320.341 230.422,317.867L282.945,278.059C285.804,275.243 290.006,274.262 293.804,275.52C319.319,283.947 346.071,288.213 373.335,288.213C379.202,288.213 384.002,292.992 384.002,298.88L384.002,373.333L384,373.333Z",
    style: {
      fill: "rgb(10,45,113)",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPrimary);
export default __webpack_public_path__ + "static/media/contact-primary.813e6f8168e5674887dd4c3d7cb02cad.svg";
export { ForwardRef as ReactComponent };